import angular from 'angular';
import CommentFormController from './comment-form.controller';

import './comment-form.styles.scss';

export default angular.module('directives.commentForm', [])
  .directive('commentForm', () => {
    'ngInject';

    return {
      controller: CommentFormController,
      restrict: 'E',
      replace: true,
      scope: {
        context: '@',
        contextId: '@',
        placeholder: '@?',
        selectedTypes: '=?',
      },
      templateUrl: require('./comment-form.template.html'),
    };
  })
  .name;
